var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{staticClass:"page-wrapper have-bottom-menu",attrs:{"justify":"center"}},[_c('van-col',{staticClass:"itserve-center place-content-center flex-display-fix",attrs:{"span":"24"}},[_c('kharkov-obl-energo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }